export const recaptchaSiteKey = '6Lf53NgZAAAAAE8UfRgjGm-IbE2I8LQJsf5jbaZq';
export const GOOGLE_ANALYTICS_TRACKER_ID = 'UA-195132386-1';
export const FACEBOOK_PIXEL_ID = '381113343054373';
export const GOOGLE_ADWORDS_CONVERSION_ID = 'AW-464100079/aNcmCIvTq5sCEO-1pt0B';
export const GOOGLE_ANALITY_MEASURENMENT_ID = 'G-RLV2R9MYTD';
